import { render } from "./LicensePage.vue?vue&type=template&id=7dc9c5f4&ts=true"
import script from "./LicensePage.vue?vue&type=script&lang=ts"
export * from "./LicensePage.vue?vue&type=script&lang=ts"

import "./LicensePage.vue?vue&type=style&index=0&id=7dc9c5f4&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__